<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 14 14"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M7 10.2223V13.139"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.25014 6.58229C5.25003 6.79934 5.18937 7.01205 5.07498 7.19651C4.96059 7.38098 4.79702 7.52987 4.60264 7.62646L3.56431 8.15146C3.36994 8.24804 3.20636 8.39694 3.09197 8.5814C2.97759 8.76586 2.91692 8.97857 2.91681 9.19562V9.63896C2.91681 9.79367 2.97827 9.94204 3.08766 10.0514C3.19706 10.1608 3.34543 10.2223 3.50014 10.2223H10.5001C10.6549 10.2223 10.8032 10.1608 10.9126 10.0514C11.022 9.94204 11.0835 9.79367 11.0835 9.63896V9.19562C11.0834 8.97857 11.0227 8.76586 10.9083 8.5814C10.7939 8.39694 10.6304 8.24804 10.436 8.15146L9.39764 7.62646C9.20327 7.52987 9.03969 7.38098 8.92531 7.19651C8.81092 7.01205 8.75026 6.79934 8.75014 6.58229V4.38896C8.75014 4.23425 8.8116 4.08587 8.921 3.97648C9.03039 3.86708 9.17877 3.80562 9.33348 3.80562C9.6429 3.80562 9.93964 3.68271 10.1584 3.46392C10.3772 3.24512 10.5001 2.94838 10.5001 2.63896C10.5001 2.32954 10.3772 2.03279 10.1584 1.814C9.93964 1.59521 9.6429 1.47229 9.33348 1.47229H4.66681C4.35739 1.47229 4.06064 1.59521 3.84185 1.814C3.62306 2.03279 3.50014 2.32954 3.50014 2.63896C3.50014 2.94838 3.62306 3.24512 3.84185 3.46392C4.06064 3.68271 4.35739 3.80562 4.66681 3.80562C4.82152 3.80562 4.96989 3.86708 5.07929 3.97648C5.18869 4.08587 5.25014 4.23425 5.25014 4.38896V6.58229Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 2.5L11.5 11.5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPushpinOff',
	props: {
		size: {
			type: [Number, String],
			default: 14
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.16375
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedStroke() {
			return this.color
		}
	}
}
</script>
